import { render, staticRenderFns } from "./PageTrend.vue?vue&type=template&id=775932d2&scoped=true&"
import script from "./PageTrend.vue?vue&type=script&lang=js&"
export * from "./PageTrend.vue?vue&type=script&lang=js&"
import style0 from "./PageTrend.vue?vue&type=style&index=0&id=775932d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775932d2",
  null
  
)

component.options.__file = "PageTrend.vue"
export default component.exports